<section class="ticket-dialog-wrap" *ngIf="showDialog" [class.versionV2]="viewConfigurations.useMobileViewWithTopMenu">
  <!-- <div class="overlay blur"></div> -->
  <div class="ticket-detail-wrap box" id="ticketDetailWrap" #ticketDetailWrap>
    <div class="close-wrap" [class.played]="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket">
      <div class="close" (click)="closeDialog()">
        <i class="icon icon-cross"></i>
      </div>
    </div>
    <div class="ticket-detail-header">
      <div class="ticket-info" *ngIf="dialogModel.createdOnDate">{{dialogModel.createdOnDate}}</div>
      <div class="title {{ticketStatusEnum[dialogModel.confirmationOrPlayedTicket?.statusId] | lowercase}}" [class.red]="dialogModel.ticketType === ticketPlayTypeEnum.ConfirmationTicket || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket">
        <ng-container *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket">
          {{dynamicTranslations['ticketAndOtherStatuses_'+[ticketStatusEnum[dialogModel.confirmationOrPlayedTicket?.statusId]]]
          ? dynamicTranslations['ticketAndOtherStatuses_' +
          [ticketStatusEnum[dialogModel.confirmationOrPlayedTicket?.statusId]]] :
          dialogModel.confirmationOrPlayedTicket?.ticketStatus }}
        </ng-container>
        <ng-container
          *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.ConfirmationTicket || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket"
          i18n="ConfirmTicketChanges Title@@ConfirmTicketChangesTitle"> DOŠLO JE DO PROMENE NA VAŠEM TIKETU
        </ng-container>
        <ng-container *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet"
          i18n="ConfirmTicket Title@@ConfirmTicketTitle"> POTVRDA UPLATE</ng-container>
      </div>
      <div class="ticket-id" *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket">
        {{dialogModel.confirmationOrPlayedTicket?.ticketId}}
      </div>
    </div>

    <div class="line d-none"></div>


    <div class="ticket-detail-body" id="ticket-detail-body" [class.multi-items]="orderingForTicketItemGroups.length > 1">
      <div class="row-wrap">
        <div class="row" *ngFor="let eventOrder of orderingForTicketItemGroups">
          <div class="flex-full-width">
            <div class="col col-time">
              <span class="small-text">
                {{dialogModel.ticketItemEventGroups[eventOrder.eventId].eventDateTime | date:"dd.LL.YY HH:mm"}}
                <!-- {{dialogModel.ticketItemEventGroups[eventOrder.eventId].eventTime}}
                {{dialogModel.ticketItemEventGroups[eventOrder.eventId].eventDayShort}} -->
              </span>
              <span>{{dialogModel.ticketItemEventGroups[eventOrder.eventId].eventCode}}</span>
            </div>
            <div class="col" *ngIf='viewConfigurations.showSportIconInTicket'>
              <i
                class="icon-xs s-icon-{{getSportName(dialogModel.ticketItemEventGroups[eventOrder.eventId].sportId)}} sportid-{{dialogModel.ticketItemEventGroups[eventOrder.eventId].sportId}}"></i>
            </div>
            <div class="col col-event-name">
              <div class="event-name">
                <span class="home">{{dialogModel.ticketItemEventGroups[eventOrder.eventId].eventHomeTeam}}</span>
                <span class="away">{{dialogModel.ticketItemEventGroups[eventOrder.eventId].eventAwayTeam}}</span>
              </div>
              <div class="special-events"
                *ngIf="dialogModel.ticketItemEventGroups[eventOrder.eventId].mappingType != eventMappingTypeEnum.StandardEvent">
                <span class="super-bet"
                  *ngIf="dialogModel.ticketItemEventGroups[eventOrder.eventId].mappingType == eventMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</span>
                <span class="super-bet"
                  *ngIf="dialogModel.ticketItemEventGroups[eventOrder.eventId].mappingType == eventMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</span>
              </div>
            </div>
            <div *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket" class="col col-result">
              <ng-container *ngIf="dialogModel.ticketItemEventGroups[eventOrder.eventId].liveScore; else prematchResult">
                <div class="flex home">
                  <span class="current-score">{{dialogModel.ticketItemEventGroups[eventOrder.eventId].liveScore.homeScore}}</span>
                  <span *ngFor="let homeSetScore of dialogModel.ticketItemEventGroups[eventOrder.eventId].liveScore.homeSetScore">{{homeSetScore}}</span>
                </div>
                <div class="flex away">
                  <span class="current-score">{{dialogModel.ticketItemEventGroups[eventOrder.eventId].liveScore.awayScore}}</span>
                  <span *ngFor="let awaySetScore of dialogModel.ticketItemEventGroups[eventOrder.eventId].liveScore.awaySetScore">{{awaySetScore}}</span>
                </div>

              </ng-container>

              <ng-template #prematchResult>
                <div class="flex home">
                  <ng-container *ngFor="let score of dialogModel.ticketItemEventGroups[eventOrder.eventId].scores">
                    <span class="current-score" *ngIf="score.scoreGroupId === 2 ">{{score.scorePeriods[0].homeAwayValue[1]}}</span>
                  </ng-container>

                  <ng-container *ngFor="let score of dialogModel.ticketItemEventGroups[eventOrder.eventId].scores">
                    <ng-container *ngIf="score.scoreGroupId !== 2 && score.hasHomeAway">
                      <ng-container *ngFor="let period of score.scorePeriods">
                        <span> {{period.homeAwayValue[1]}}</span>
                      </ng-container>
                    </ng-container>

                  </ng-container>

                </div>
                <div class="flex away">
                  <ng-container *ngFor="let score of dialogModel.ticketItemEventGroups[eventOrder.eventId].scores">
                    <span class="current-score" *ngIf="score.scoreGroupId === 2 ">{{score.scorePeriods[0].homeAwayValue[2]}}</span>
                  </ng-container>
                  <ng-container *ngFor="let score of dialogModel.ticketItemEventGroups[eventOrder.eventId].scores">
                    <ng-container *ngIf="score.scoreGroupId !== 2 && score.hasHomeAway">
                      <ng-container *ngFor="let period of score.scorePeriods">
                        <span> {{period.homeAwayValue[2]}}</span>
                      </ng-container>
                    </ng-container>

                  </ng-container>
                </div>
              </ng-template>


              <!-- <span>{{dialogModel.ticketItemEventGroups[eventOrder.eventId].result | split : 0}}</span>
                            {{dialogModel.ticketItemEventGroups[eventOrder.eventId].result | split : 1}} -->
            </div>
          </div>

          <div class="flex">

            <div class="col col-outcome-info">
              <div class="flex mobile-description" *ngIf="isMobileView">
                <div class="btn small outcome" i18n="Ticket Items Type of game first Capitalized@@TicketItemsType">Tip
                </div>
                <div class="btn small odd" i18n="Score first Capitalized@@Odd">Kvota</div>
                <div class="btn small system" i18n="System text@@myTicketSystemSystem">Sistem</div>
              </div>
              <div class="flex disabled" *ngFor="let outcomeId of eventOrder.outcomeIds">
                <div
                  class="btn small outline-light outcome {{betOutcomeResultEnum[dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].status] | lowercase}}-outcome">
                  <span class="description"
                    i18n="Ticket Items Type of game first Capitalized@@TicketItemsType">Tip</span>
                  <div class="outcome-name-wrap">
                    <div class="name">
                      {{dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].betName}}</div>
                    <div *ngIf="dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].sbv">
                      (<ng-container *ngIf="!dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].useSbvHandicapPipe">{{dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].sbv}}</ng-container>
                      <ng-container *ngIf="dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].useSbvHandicapPipe">{{dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].sbv | handicapSbv}}</ng-container>)
                    </div>
                    <div>/
                      {{dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].betOutcomeName}}
                    </div>

                  </div>
                </div>
                <div class="btn small outline-light odd">
                  <span class="description" i18n="Score first Capitalized@@Odd">Kvota</span>

                  <ng-container
                    *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket || (dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].isBetOutcomePlayable && dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].isBetPlayable && dialogModel.ticketItemEventGroups[eventOrder.eventId].isEventPlayable && dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].odd > 1); else lockedWrap">
                    <span class="odd old-odd"
                      *ngIf="dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].oldOdd != dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].odd"
                      [ngClass]="{'old-higher': dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].oldOdd > dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].odd, 'old-lower': dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].oldOdd < dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].odd}">
                      {{dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].oldOdd | odd}}
                    </span>
                    <span class="odd current-odd">
                      {{dialogModel.ticketItemEventGroups[eventOrder.eventId].ticketItems[outcomeId].odd | odd}}
                    </span>
                  </ng-container>
                  <ng-template #lockedWrap>
                    <i class="icon icon-ex-sm icon-lock"></i>
                  </ng-template>
                </div>
                <div class="btn small outline-light system">
                  <span class="description system-description" i18n="System text@@myTicketSystemSystem">Sistem</span>
                  <div class="system-value">
                    <span
                      *ngIf="dialogModel.ticketItemEventGroups[eventOrder.eventId].isInBankersGroup || dialogModel.isFix"
                      class="bold">F</span>
                    <span
                      *ngIf="!dialogModel.ticketItemEventGroups[eventOrder.eventId].isInBankersGroup && (!dialogModel.isFix)">
                      <span *ngIf="selectedSystemOptions; else noSystemOption">
                        <ng-container *ngFor="let systemOption of selectedSystemOptions; let i = index">
                          <ng-container *ngIf="systemOption.optionSelected">
                            <ng-container *ngIf="i>0">,</ng-container>{{systemOption.eventsInCombination}}
                          </ng-container>
                        </ng-container>
                        <ng-container>/{{selectedSystemOptions[0]?.totalNumberOfEvents}}</ng-container>
                      </span>
                      <ng-template #noSystemOption>
                        <span *ngIf="dialogModel.confirmationOrPlayedTicket">
                          {{dialogModel.confirmationOrPlayedTicket.systemName}}
                        </span>
                      </ng-template>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>

      </div>

    </div>
    <div class="ticket-detail-bottom">
      <div class="items-total-odd">
        <span>
          <ng-container i18n="Ticket Items Number Of Events first Capitalized@@TicketItemsNumberOfEvents">Broj parova </ng-container>:
          <span class="bold"> {{ticketItemsLength}}</span>
        </span>
        <span *ngIf="dialogModel.ticketType != ticketPlayTypeEnum.ConfirmationTicket; else confirmationTotal">
          <ng-container i18n="Total Odd ticket calculator@@TotalOdd">Kvota</ng-container>:
          <span class="bold"> {{dialogModel.ticketData.totalOdd | number:'1.2-2'}} </span>
        </span>
        <ng-template #confirmationTotal>
          <div class="total-odd-wrap">
            <span>
              <ng-container i18n="Requested Odd ticket calculator@@RequestedOdd">Zahtevana kvota</ng-container>:
              {{dialogModel.requestedTotalOdd | number:'1.2-2'}}
            </span>
            <span class="changed" *ngIf="dialogModel.ticketData.totalOdd != dialogModel.requestedTotalOdd">
              <ng-container i18n="Adjusted Odd ticket calculator@@AdjustedOdd">Korigovana kvota</ng-container>:
               {{dialogModel.ticketData.totalOdd | number:'1.2-2'}}
            </span>
          </div>
        </ng-template>
      </div>

      <div class="payout-wrap">
        <div class="flex33" *ngIf="dialogModel.requestedStake == dialogModel.ticketData.totalStake || dialogModel.ticketType != ticketPlayTypeEnum.ConfirmationTicket; else confirmationStake">
          <ng-container i18n="Ticket Pay in text@@TicketPayIn">Uplata</ng-container>:
          <span> {{dialogModel.ticketData.payin | number:'1.2-2'}} {{currency}}</span>
          <div class=""
            *ngIf="dialogModel.ticketData.totalStake != dialogModel.ticketData.payin && viewConfigurations.addPropertiesOnticketDialog">
            <ng-container i18n="Total stake on ticket@@TotalStakeWithoutTax">Ulog</ng-container>:
            <span *ngIf="taxBeforeStakeDefinitionPercent && viewConfigurations.showOptionsOnTicketDialog"> (-{{taxBeforeStakeDefinitionPercent}}% mt)</span>
            <span>{{dialogModel.ticketData.totalStake | number:'1.2-2'}} {{currency}}</span>
          </div>
          <div class="" *ngIf="dialogModel.ticketData.totalStake != dialogModel.ticketData.payin && viewConfigurations.addPropertiesOnticketDialog">
            <ng-container>Porez na uplatu</ng-container>:
            <span> {{dialogModel.ticketData.taxBeforeStake | number:'1.2-2'}} {{currency}}</span>
        </div>
      </div>
        <ng-template #confirmationStake>
          <div>
            <div>
              <ng-container i18n="Requested Stake ticket calculator@@RequestedStake">Zahtevana uplata</ng-container>:
              <span> {{dialogModel.requestedPayIn | number:'1.2-2'}} {{currency}}</span>
            </div>
            <div class="changed">
              <ng-container i18n="Adjusted Stake ticket calculator@@AdjustedStake">Korigovana uplata</ng-container>:
              <span> {{dialogModel.ticketData.payin | number:'1.2-2'}} {{currency}}</span>
            </div>
         </div>
        </ng-template>
        <div class="flex33 center" *ngIf="viewConfigurations.showOptionsOnTicketDialog">
          <ng-container i18n="Bonus ticket calculator@@Bonus">Bonus</ng-container>:
          <span> {{dialogModel.ticketData.bonus | number:'1.2-2'}}</span>
        </div>
        <div class="flex33 right">
          <span class="bold" *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket && !dialogModel.isFix"> {{dialogModel.confirmationOrPlayedTicket.ticketTypeName}}</span>

          <ng-container *ngIf="dialogModel.ticketData.numberOfBets > 1 && dialogModel.isFix">
            <ng-container i18n="System text@@myTicketSystemSystem">Sistem</ng-container>:
            <span class="bold">Fix</span>
          </ng-container>

          <ng-container *ngIf="!dialogModel.isFix && dialogModel.ticketType !== ticketPlayTypeEnum.PlayedTicket">
            <ng-container *ngIf="dialogModel.bankerTicketItemGroups?.length > 0">Fix:<span
                class="bold">{{dialogModel.bankerTicketItemGroups.length}}</span> + </ng-container>

            <ng-container i18n="System text@@myTicketSystemSystem">Sistem</ng-container>:
            <span class="bold nowrap" *ngIf="selectedSystemOptions">
              <ng-container *ngFor="let systemOption of selectedSystemOptions; let i = index">
                <ng-container *ngIf="systemOption.optionSelected">
                  <ng-container *ngIf="i>0">, </ng-container>{{systemOption.eventsInCombination}}</ng-container>
              </ng-container>

              <ng-container class="bold">/ {{selectedSystemOptions[0]?.totalNumberOfEvents}}</ng-container>
            </span>

          </ng-container>
          <div class=""
            *ngIf="dialogModel.ticketData.numberOfBets > 1 && dialogModel.ticketType == ticketPlayTypeEnum.ConfirmationTicket && dialogModel.ticketData.taxOnWinings && viewConfigurations.addPropertiesOnticketDialog">
            <ng-container i18n="Max possible win ticket calculator@@PossibleWin">Moguci Dobitak</ng-container>: <span>
              {{dialogModel.ticketData.possibleWin | number:'1.2-2'}} {{currency}}</span>
          </div>
          <div *ngIf="dialogModel.ticketData.numberOfBets == 1 || (viewConfigurations.addPropertiesOnticketDialog  && dialogModel.ticketType !== ticketPlayTypeEnum.ConfirmationTicket)">
            <ng-container i18n="Possible win ticket calculator@@PossibleWin">Moguci Dobitak</ng-container>:
            <span> {{dialogModel.ticketData.possibleWin | number:'1.2-2'}} {{currency}}</span>
          </div>

          <div class=""
            *ngIf="dialogModel.ticketData.taxOnWinings && viewConfigurations.addPropertiesOnticketDialog">
            <ng-container i18n="Tax on winnings@@TaxOnWinings">Porez</ng-container>: <span>
              {{dialogModel.ticketData.taxOnWinings | number:'1.2-2'}} {{currency}}</span>
          </div>
          <div
            *ngIf="dialogModel.ticketType != ticketPlayTypeEnum.PlayedTicket && dialogModel.ticketData.numberOfBets == 1 && viewConfigurations.addPropertiesOnticketDialog">
            <ng-container i18n="Ticket Pay out text@@TicketPayOut">Isplata</ng-container>:
            <span> {{dialogModel.ticketData.possibleWinWithoutTax | number:'1.2-2'}} {{currency}}</span>
          </div>
          <div class=""
            *ngIf="(dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket && dialogModel.ticketData.numberOfBets === 1) && dialogModel.ticketData.taxOnWinings && viewConfigurations.addPropertiesOnticketDialog">
            <ng-container i18n="Possible paout ticket calculator@@PossiblePayout">Ev. isplata</ng-container>: <span> {{dialogModel.ticketData.possiblePayout | number:'1.2-2'}}
              {{currency}}</span>
          </div>

        </div>
      </div>

      <div class="line" *ngIf="dialogModel.ticketData.numberOfBets > 1"></div>

      <div class="pay-payout" *ngIf="dialogModel.ticketData.numberOfBets > 1">
        <div>
          <!-- <ng-container  *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket"> -->
            <ng-container i18n="Minimum Pay Out ticket calculator@@MinimumPayOut">Min isplata</ng-container>:
            <span> {{dialogModel.ticketData.possibleMinPayout | number:'1.2-2'}} {{currency}}</span>
          <!-- </ng-container> -->
        </div>
        <!-- <div class="" *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlaceBet && dialogModel.ticketData.totalStake && dialogModel.ticketData.taxOnMinWinning && viewConfigurations.addPropertiesOnticketDialog"> -->
        <div class="" *ngIf="dialogModel.ticketData.totalStake && dialogModel.ticketData.taxOnMinWinning && viewConfigurations.addPropertiesOnticketDialog">
          <ng-container>Porez na minimalnu isplatu</ng-container>: <span> {{dialogModel.ticketData.taxOnMinWinning |
            number:'1.2-2'}} {{currency}}</span>
        </div>
        <div *ngIf="dialogModel.ticketType != ticketPlayTypeEnum.PlayedTicket">
          <ng-container i18n="Maximum Pay Out ticket calculator@@MaximumPayOut">Max isplata</ng-container>: <span>
            {{dialogModel.ticketData.possibleWinWithoutTax | number:'1.2-2'}} {{currency}}</span>
        </div>
        <div *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket">
          <ng-container i18n="Maximum Pay Out ticket calculator@@MaximumPayOut">Max isplata</ng-container>: <span>
             {{dialogModel.ticketData.possiblePayout | number:'1.2-2'}} {{currency}}</span>
        </div>
        <!-- <div><ng-container i18n="Maximum Pay Out ticket calculator@@MaximumPayOut">Max dobitak: </ng-container> <span> {{dialogModel.ticketData.possibleWin | number:'1.2-2'}} {{currency}}</span></div> -->
      </div>
      <div class="line"  *ngIf="!(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket) && dialogModel.ticketData.numberOfBets > 1" ></div>

      <div class="casheOut-button-wrap" [class.disabled]="!playedTicketPinCodeInput" *ngIf="(!affiliate || affiliate?.affiliateRole === affiliateRoleEnum.cashier) && dialogModel.confirmationOrPlayedTicket?.cashOutValue != null && dialogModel.confirmationOrPlayedTicket?.cashOutValue != 0">
        <div class="btn outline-primary small" (click)="sellBet()" >
          <img class="cashout-icon" src="assets/img/CashOUT.svg">
          <span i18n="Casheback text@@Casheback">Cashout</span>: {{dialogModel.confirmationOrPlayedTicket.cashOutValue | number:'1.2-2'}} {{currency}}
        </div>
      </div>



      <app-winnings-per-hit *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket && dialogModel.ticketData.possibleWinForNumberOfHits?.length > 1" [possibleWinForNumberOfHits]="dialogModel.ticketData.possibleWinForNumberOfHits"> </app-winnings-per-hit>

      <ng-container
        *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket">
        <div class="alert danger" *ngIf="this.dialogModel.ticketData.hasLowerOdds && dialogModel.validationMode == oddsValidationModeEnum.AcceptHigherOdds">
          <ng-container>{{dynamicTranslations.ticketValidation_OddChangedAfterAddedToTicket}}</ng-container>
        </div>
        <div class="line"></div>

        <div class="odd-change-wrap">
          <span><span i18n="ODD CHANGES SPAN@@oddChanges">PROMENA KVOTA </span>: </span>
          <div class="radio-wrap">
            <div class="custom-radio">
              <input type="radio" id="acceptAllTicketDialog" name="acceptOddTicketDialog"
                [value]="oddsValidationModeEnum.AcceptAllOdds" [(ngModel)]="dialogModel.validationMode"
                [attr.checked]="dialogModel.validationMode == oddsValidationModeEnum.AcceptAllOdds">
              <label for="acceptAllTicketDialog"
                (click)="changeOddsValidationMode(oddsValidationModeEnum.AcceptAllOdds)"
                i18n="Accept all changes radio@@AcceptAll">Prihvati sve</label>
            </div>
            <div class="custom-radio">
              <input type="radio" id="acceptHigherTicketDialog" name="acceptOddTicketDialog"
                [value]="oddsValidationModeEnum.AcceptHigherOdds" [(ngModel)]="dialogModel.validationMode"
                [attr.checked]="dialogModel.validationMode == oddsValidationModeEnum.AcceptHigherOdds">
              <label for="acceptHigherTicketDialog"
                (click)="changeOddsValidationMode(oddsValidationModeEnum.AcceptHigherOdds)"
                i18n="Accept higher changes radio@@AcceptHigher">Prihvati veću</label>
            </div>
            <!-- // commneted because notifications are not redy for deploy
                        <div *ngIf="isUserLoggedInForNot" class="custom-radio">
                            <input type="checkbox" id="notificationTicketDialog" name="notificationTicketDialog"  (change)="receiveNotification=!receiveNotification" [checked]="receiveNotification">
                            <label for="notificationTicketDialog">Notifikacije</label>
                        </div>  -->
          </div>
        </div>
      </ng-container>
      <div class="ticket-option" *ngIf="dialogModel.ticketType !== ticketPlayTypeEnum.PlayedTicket">
        <ng-container
          *ngIf="!dialogModel.ticketData.isTicketOnline || maxTotalOdd < this.dialogModel.ticketData.totalOdd; else ticketIsOnline">
          <div class="alert danger" *ngIf="!dialogModel.ticketData.isTicketOnline">
            <ng-container i18n="Offline Events In Ticket ticket calculator button@@OfflineEventsInTicket">OFFLINE
              događaji na tiketu</ng-container>
          </div>
          <div class="alert danger" *ngIf="dialogModel.ticketData.isTicketOnline">{{errorMsg}} {{maxTotalOdd |
            number:'1.2-2'}}</div>
        </ng-container>

        <ng-template #ticketIsOnline>
          <div class="buttons-wrap">
            <button id="btnFreeBet" class="btn outline-primary small"
              [class.offline]="maxTotalOdd < dialogModel.ticketData.totalOdd"
              *ngIf="(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket) && isUserLoggedIn && dialogModel.ticketData.freeBetValue > 0 && freeBetBalance >= dialogModel.ticketData.payin"
              (click)="freeBetTicket()">
              <ng-container i18n="Freebet button@@Freebet">FREEBET</ng-container>
            </button>
            <button id="btnExpressTicket" class="btn outline-primary small"
              *ngIf="(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket) && !tmUser && !(affiliate?.affiliateRole === affiliateRoleEnum.cashier)"
              [class.offline]="maxTotalOdd < this.dialogModel.ticketData.totalOdd" (click)="fastTicket()">
              <ng-container i18n="Express tiket button@@ExpressTicket">EXPRESS TIKET</ng-container>
            </button>
            <button id="btnConfirmTicketConfirm" class="btn outline-primary small"
              *ngIf="(dialogModel.ticketType === ticketPlayTypeEnum.PlaceBet || dialogModel.ticketType === ticketPlayTypeEnum.ChangedTicket)
                                      && ((isUserLoggedIn && accountBalance >= dialogModel.ticketData.payin && !affiliate)
                                        || (tmUser && tmUser.isC)
                                        || (affiliate && affiliate?.affiliateRole === affiliateRoleEnum.cashier && affiliate?.currentBalance >= dialogModel.ticketData.payin )                            )"
              [class.offline]="maxTotalOdd < this.dialogModel.ticketData.totalOdd" (click)="placeStandardBet()">
              <ng-container i18n=" Confirm Ticket confirm button@@ConfirmTicketConfirm">UPLATA</ng-container>
            </button>


            <button id="btnCancelTicket" class="btn outline-primary small"
              *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.ConfirmationTicket" (click)="cancelTicket()">
              <ng-container i18n="ticket COnfirmation Ticket button@@CancelTicket">ODUSTANI</ng-container>
            </button>
            <button id="btnConfirmationTicket" class="btn outline-primary small"
              *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.ConfirmationTicket"
              (click)="makeRequest(dialogModel.confirmationOrPlayedTicket)">
              <span i18n="ticket COnfirmation Ticket button@@ConfirmationTicket">PRIHVATI</span>
              <span *ngIf="timeToAccept > 0"> ({{timeToAccept}})</span>
            </button>
          </div>
        </ng-template>
      </div>
      <div class="ticket-option"
        *ngIf="dialogModel.ticketType === ticketPlayTypeEnum.PlayedTicket
        && (tmUser || affiliate && affiliate.affiliateRole === affiliateRoleEnum.cashier)
        && (
          ticketStatusEnum.Pending === dialogModel.confirmationOrPlayedTicket?.statusId
          || ticketStatusEnum.Open === dialogModel.confirmationOrPlayedTicket?.statusId
          || ticketStatusEnum.Passed === dialogModel.confirmationOrPlayedTicket?.statusId
          || ticketStatusEnum.Won === dialogModel.confirmationOrPlayedTicket?.statusId
          || ticketStatusEnum.Void === dialogModel.confirmationOrPlayedTicket?.statusId
          || ticketStatusEnum.CashBack === dialogModel.confirmationOrPlayedTicket?.statusId
        )">
        <div class="line"></div>
          <div class="buttons-wrap">
            <div class="pin-wrap" *ngIf="!(ticketStatusEnum.Pending === dialogModel.confirmationOrPlayedTicket?.statusId
          || ticketStatusEnum.Open === dialogModel.confirmationOrPlayedTicket?.statusId) ||  (dialogModel.confirmationOrPlayedTicket?.cashOutValue != null && dialogModel.confirmationOrPlayedTicket?.cashOutValue != 0) || viewConfigurations.requestPinForStornoAndPayout">
              <label for="pinInputTicketDialog">Ticket PIN</label>
              <input id="pinInputTicketDialog" class="code2 form-control form-control-sm" type="text" [(ngModel)]="playedTicketPinCodeInput" placeholder="0000" maxlength="4">
            </div>
            <div class="rebet-button-wrap" *ngIf="dialogModel.ticketType == ticketPlayTypeEnum.PlayedTicket && dialogModel.ticketData.isTicketOnline">
              <div class="btn primary small" (click)="rebet()" >
                <i class="icon icon-undo"></i>
                <!-- <i class="sporticon sporticon-cash icon-xs m-r"></i> -->
                <span i18n="TM Rebet@@Rebet">REBET</span>
              </div>

            </div>
            <button id="btnStornoTicket" class="btn outline-primary small" [class.disabled]="!playedTicketPinCodeInput && viewConfigurations.requestPinForStornoAndPayout || !isStornoPossible"
              *ngIf="ticketStatusEnum.Pending === dialogModel.confirmationOrPlayedTicket?.statusId || ticketStatusEnum.Open === dialogModel.confirmationOrPlayedTicket?.statusId"
              (click)="stornoTicket()">
              <span>CANCEL TICKET</span>
            </button>
            <button id="btnPayOutTicket" class="btn outline-primary small" [class.disabled]="!playedTicketPinCodeInput && viewConfigurations.requestPinForStornoAndPayout" *ngIf="ticketStatusEnum.Passed === dialogModel.confirmationOrPlayedTicket?.statusId
                  || ticketStatusEnum.Won === dialogModel.confirmationOrPlayedTicket?.statusId
                  || ticketStatusEnum.Void === dialogModel.confirmationOrPlayedTicket?.statusId
                  || ticketStatusEnum.CashBack === dialogModel.confirmationOrPlayedTicket?.statusId" (click)="payoutTicket()">
              <span>Payout Ticket</span>
            </button>
            <!-- ADD PIN CHECK FUNCTIONALITY -->
            <!-- <div class="btn outline-primary small casheOut-button-wrap with-pin" (click)="sellBet()" [class.disabled]="!playedTicketPinCodeInput" *ngIf="affiliate && dialogModel.confirmationOrPlayedTicket?.cashOutValue != null && dialogModel.confirmationOrPlayedTicket?.cashOutValue != 0">
              <img class="cashout-icon" src="assets/img/CashOUT.svg">
              <span i18n="Casheback text@@Casheback">Cashout</span>: {{dialogModel.confirmationOrPlayedTicket.cashOutValue | number:'1.2-2'}} {{currency}}
            </div> -->
          </div>
        <div class="line"></div>
      </div>
      <div class="invalid-place-bet alert primary"
      *ngIf="(!isUserLoggedIn
      || (!affiliate && dialogModel.ticketData.payin > accountBalance)
      || (affiliate?.affiliateRole === affiliateRoleEnum.cashier && affiliate?.currentBalance < dialogModel.ticketData.payin)
      ) && dialogModel.ticketType != ticketPlayTypeEnum.PlayedTicket">
        <span *ngIf="!isUserLoggedIn" i18n="ticket Confirm not logged in@@ConfirmTicketNotLoggedIn">za uplatu tiketa,
          morate biti ulogovani</span>
        <span *ngIf="
          (isUserLoggedIn && !affiliate && dialogModel.ticketData.payin > accountBalance)
          || (affiliate?.affiliateRole === affiliateRoleEnum.cashier && affiliate?.currentBalance < dialogModel.ticketData.payin)"><span
            i18n="ticket Confirm not enough funds@@ConfirmTicketNotEnoughFunds">nedovoljno sredstava na racunu, za
            uplatu tiketa</span> - {{affiliate? affiliate?.currentBalance : accountBalance | number:'1.2-2'}} {{currency}}</span>
      </div>
      <button  *ngIf="dialogModel.ticketType !== ticketPlayTypeEnum.PlaceBet && dialogModel.ticketType !== ticketPlayTypeEnum.ChangedTicket" class="exportToPdf" (click)="generatePdfFromTicket()">Export To PDF</button>

    </div>
  </div>
</section>
